import React, { useState, useEffect } from "react";
import { Modal, Checkbox, Typography, Button, message, Input, InputNumber } from "antd";
import { typeMap3 } from "@/constants/dataMap";
import { subjobs,getSubjob } from "@/services/common";
import { userJobInteraction } from "@/services/jobs";
import userInfo from "@/Components/user";
import { validateInput } from "./validateInput";
import { buildTaskInput as newBuildTaskInput } from "@/Pages/Project/Flow/FlowDesign/func/buildInput";
import {openErrorNotification} from '@/Components/Diagram/ErrorsNotice'
import {getSubJobs } from "@/services/common";
import GroupCalParamsPreview from "./ParamsPreview";

const { Text } = Typography;

interface SelectElementsModalProps {
  visible: boolean;
  jsonData: any;
  onClose: () => void;
  onSuccess?: () => void;
  state: any;
  notificationApi?: any;
  notificationKey?: string;
  setSelectedItem?: any;
  selectElement: (newElementType: string, newElement: any) => void;
  setLoadingVariable?:(newLoadingVariable)=>void;
  setQueryTask?:()=>void;
  multipleNodes?:any;
  setChangeLinkFlowValue?:(newChangeLinkFlowValue)=>void;
  setQueryAllSubJobsToFlowValue?:(newQueryAllSubJobsToFlowValue)=>void;
}

const SelectElementsModal: React.FC<SelectElementsModalProps> = ({
  visible,
  jsonData,
  onClose,
  onSuccess,
  state,
  notificationApi,
  notificationKey,
  setSelectedItem,
  selectElement,
  setLoadingVariable,
  setQueryTask,
  multipleNodes,
  setChangeLinkFlowValue,
  setQueryAllSubJobsToFlowValue,
}) => {
  const [selectedElements, setSelectedElements] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [taskName, setTaskName] = useState("");
  const [queryAllSubJobsToFlowValueVariable,setQueryAllSubJobsToFlowValueVariable] = useState<number>(0);
  const [maxWaitMinutes, setMaxWaitMinutes] = useState<number | null>(30); //最大计算时间(分)，默认30；允许删空再输入

  // console.log("jsonData", jsonData);

  useEffect(() => {
    if (visible) 
    {
      if(multipleNodes && multipleNodes.length>0)
      {
        setSelectedElements(multipleNodes.map(obj => obj["nodeName"]));
      }
      else
      {
        //默认
        setSelectedElements([]);
      }
    }
  }, [visible]);

  const handleSelectAll = (e: any) => {
    if (e.target.checked) {
      setSelectedElements(allItemNames);
    } else {
      setSelectedElements([]);
    }
  };

  const allItems = (jsonData?.nodeDataArray || []).filter(
    (item: any) => !item.isGroup && item.elementName && item.nodeName.trim() !== "",
  );
  const allItemNames = allItems.map((item: any) => item.nodeName);
  const isAllSelected = selectedElements.length === allItemNames.length && allItemNames.length > 0;
  const isIndeterminate =
    selectedElements.length > 0 && selectedElements.length < allItemNames.length;

  const groupMap = new Map<string, any[]>();
  allItems.forEach((item: any) => {
    const type = item.type || "未分类";
    if (!groupMap.has(type)) groupMap.set(type, []);
    groupMap.get(type)!.push(item);
  });

  const handleOk = async () => {
    if (taskName.trim() === "") {
        message.warning("请输入计算名称");
        return;
      }
    // api.destroy(notificationKey);
    if (selectedElements.length === 0) {
      message.warning("请至少选择一个单元");
      return;
    }

    //校验是否重名
    let jobId = jsonData.job_id;
    const token = userInfo.access_token;
    let res0 = await getSubJobs({ job_id:jobId}, token);
    if (res0.status === 200) 
    {
      let subJobs = res0.data.filter((item) => item.type === "multi");
      if((subJobs.map(obj => obj["name"])).includes(taskName.trim()))
      {
        message.warning("组合计算结果名称重复");
        return;
      }
    } 
    else 
    {
      message.error(`getSubJobs查询失败：${res0.status}`);
      return;
    }

    setLoading(true);

    try {
      // setLoadingVariable(true);
      const input: any = newBuildTaskInput(
        jsonData,
        selectedElements,
        state,
        "True",
        taskName,
        "creat",
      );
      input.mix_input["max_wait_minutes"] = maxWaitMinutes ?? 30; //最大计算时间(分)
      // input.name = selectedElements.join(",");
      // console.log(input);

      //暂时先提交测试数据
      // const tempupdate = {
      //   // name:input.name,
      //   name: taskName,
      //   mix_input: newInput.inputs,
      //   flow_id: state.curFlow["id"],
      //   cal: "True",
      //   description: "",
      // };
      // console.log("input:", input);
      

      // console.log("validateInput:", validateInput(input.mix_input));
      const validInfo = validateInput(input["mix_input"]);
      if (validInfo === "ok") {
        // console.log("input", input);
        // console.log(validInfo);
        const subdata = {
          job_id: jsonData.job_id,
          job_type: "simulation",
          name: taskName,
          cal: "True",
          type:"multi",  //组合元件计算
          input: input.mix_input,
          in_streams: input.mix_input.streams
            .filter((s: any) => s.type === "进料")
            .map((i: any) => i.name),
          out_streams: input.mix_input.streams
            .filter((s: any) => s.type === "出料")
            .map((i: any) => i.name),
          internal_streams: input.mix_input.streams
            .filter((s: any) => s.type === "内部")
            .map((i: any) => i.name),
        };

        // console.log("subdata", subdata);
        const res = await subjobs(subdata, token);
        // console.log("res", res);
        if (res.status === 200) 
        {
          message.success("提交成功");

          //提交用户任务信息，便于后续统计（单元组合计算，subjob_id 为本次子任务 id）
          userJobInteraction({
            user_id: userInfo.id,
            username: userInfo.username,
            job_id: jsonData.job_id,
            subjob_id: res.data?.id,
          }).catch((e) => console.error("提交用户任务信息失败", e));

          // onSuccess?.();
          onClose();

          //新流股动画
          setQueryAllSubJobsToFlowValueVariable(queryAllSubJobsToFlowValueVariable+1);
          setQueryAllSubJobsToFlowValue(
            {
              taskId:jsonData.job_id,
              isNeedQueryTask:true,
              variable:queryAllSubJobsToFlowValueVariable+1
            });

          //流股动画：立即以所选元件为准开启（画布上按元件找相邻流股，进料/出料/内部都不漏），
          //计算结束由轮询把 flowEnabled 置为 false 停止
          setChangeLinkFlowValue?.({
            flowEnabled: true,
            elementNames: [...selectedElements],
          });

          // //流股动画
          // setChangeLinkFlowValue({linkNames:input["mix_input"].streams.map(obj => obj["name"]),flowEnabled:true});

          // //每五秒查询一次计算结果
          // let subId = res.data.id;
          // let successQuerySubjobs = false;
          // const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  
          // while(!successQuerySubjobs)
          // {
          //   const startTime = Date.now();
  
          //   // let res2 = await getSubjobs({job_id:subdata.job_id,name:subdata.name});
          //   let res2 = await getSubjob(subId);
          //   if (res2.status === 200) 
          //   {
          //     // let subData = res2.data.find(item=>item.id===subId);
          //     let subData = res2.data;
          //     if(subData)
          //     {
          //       if(subData.status==="done"||subData.status==="error")
          //       {
          //         successQuerySubjobs = true;
          //         // setLoadingVariable(false);
  
          //         if(subData.status==="done")
          //         {
          //           message.success("计算成功");
          //           //计算成功触发刷新
          //           setQueryTask();
          //           setLoading(false);

          //           //流股动画
          //           setChangeLinkFlowValue({linkNames:input["mix_input"].streams.map(obj => obj["name"]),flowEnabled:false});

          //           //计算成功关闭弹窗
          //           onClose();
          //         }
          //         else if(subData.status==="error")
          //         {
          //           message.error("计算失败");
          //           setLoading(false);

          //           //流股动画
          //           setChangeLinkFlowValue({linkNames:input["mix_input"].streams.map(obj => obj["name"]),flowEnabled:false});
          //         }
          //       }
          //     }
          //     else
          //     {
          //       message.error(`未找到计算任务：${subId}`);
          //       successQuerySubjobs = true;
          //       // setLoadingVariable(false);

          //       //流股动画
          //       setChangeLinkFlowValue({linkNames:input["mix_input"].streams.map(obj => obj["name"]),flowEnabled:false});
          //     }
          //   }
          //   else 
          //   {
          //     message.error(`查询计算任务失败：${res2.status}`);
          //     successQuerySubjobs = true;
          //     // setLoadingVariable(false);

          //     //流股动画
          //     setChangeLinkFlowValue({linkNames:input["mix_input"].streams.map(obj => obj["name"]),flowEnabled:false});
          //   }
          //   const elapsed = Date.now() - startTime;
          //   await delay(Math.max(0, 5000 - elapsed));
          // }

        } else {
          message.error(`提交失败：${res.status}`);
        }
      } else {
        openErrorNotification(
          validInfo,
          notificationApi,
          notificationKey,
          setSelectedItem,
          jsonData,
          selectElement,
        );
        return;
      }
    } catch (error) {
      message.error("提交异常");
      // setLoadingVariable(false);
    } finally {
      setLoading(false);
      // setLoadingVariable(false);
    }
  };

  return (
    <Modal
      title="单元组合运算："
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          取消
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
          确认
        </Button>,
      ]}
      width={1000}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          marginBottom: 10,
          paddingBottom: 10,
          borderBottom: "1px solid #EEE",
        }}
      >
        <div style={{ fontSize: 14, color: "#000", marginRight: 20 }}>计算名称：</div>
        <Input
          onChange={(e) => {
            setTaskName(e.target.value);
          }}
          style={{ flex: 1 }}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 10,
          paddingBottom: 10,
          borderBottom: "1px solid #EEE",
        }}
      >
        <div style={{ fontSize: 14, color: "#000", marginRight: 20 }}>最大计算时间：</div>
        <InputNumber
          value={maxWaitMinutes}
          onChange={(v) => setMaxWaitMinutes(v ?? null)}
          style={{ width: 120 }}
          min={1}
        />
        <div style={{ fontSize: 14, marginLeft: 8 }}>分</div>
      </div>
      <div
        style={{
          fontSize: 14,
          color: "#1b6ae7",
          fontWeight: "bold",
          marginBottom: 10,
          paddingBottom: 10,
          borderBottom: "1px solid #EEE",
          maxHeight: 150,
          overflowY: "auto",
        }}
      >
        {`选择单元组合：${selectedElements.join(',')}`}
      </div>
      <div style={{ marginBottom: 16 }}>
        <Checkbox
          indeterminate={isIndeterminate}
          checked={isAllSelected}
          onChange={handleSelectAll}
        >
          全选
        </Checkbox>
      </div>
      <Checkbox.Group
        value={selectedElements}
        style={{ width: "100%", maxHeight: 300, overflowY: "auto", marginBottom: 20 }}
        onChange={(vals) => setSelectedElements(vals as string[])}
      >
        {Array.from(groupMap.entries()).map(([type, items]) => (
          <div key={type}>
            <div style={{ fontWeight: "bold", marginBottom: 10, color: "#1b6ae7" }}>
              {typeMap3[type] || type}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
              {items.map((item) => (
                <div key={item.key} style={{ flex: "0 0 auto", width: 150, marginBottom: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Checkbox value={item.nodeName} style={{ marginRight: 8 }} />
                    <Text ellipsis={{ tooltip: item.nodeName }}>{item.nodeName}</Text>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Checkbox.Group>

      {/* 输入参数预览 */}
      {/* <GroupCalParamsPreview
        jsonData={jsonData}
        selectedElements={selectedElements}
      /> */}
    </Modal>
  );
};

export default SelectElementsModal;
